import Banner from '../Components/Pages/Prototype/Banner';
import Features from '../Components/Pages/Prototype/Features';
import Header from '../Components/Shared/Header/Header';
import Join from '../Components/Pages/Collaboration/Join';
import Create from '../Components/Pages/Prototype/Create';
import Share from '../Components/Pages/Prototype/Share';
import FaqApp from '../Components/Shared/FaqApp/FaqApp';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
import Features1 from '../Components/Pages/Home/Features';
import Innovative from '../Components/Pages/Home/Innovative';
import Blogs from '../Components/Shared/BlogsSection/Blogs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';

function Prototype(){
    return(
        <>
        <Header />
        <Banner />
        <Features />
        <Join />
        <Create />
        <Share />
        <FaqApp />
        <Slider list={images}  styles="nobg-slider"/>
      <Features1 />
      <Innovative />
      <Blogs />
      <Start />
      <Footer />
        </>
    )
};
export default Prototype;